// assets/localization-links.js
// Riutilizza la logica di Shopify per il cambio lingua, mantenendo path e filtri

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.disclosure__item_el').forEach(link => {
    const currentValue = link.dataset.value;
    
    // Trova il form e l'input nascosto corrispondente
    const localizationForm = link.closest('localization-form');
    if (!localizationForm) return;
    
    const form = localizationForm.querySelector('form');
    const inputElement = form.querySelector('input[name="language_code"],input[name="country_code"]');
    
    if (!form || !inputElement) return;
    
    // Intercetta il click per usare la logica di Shopify
    link.addEventListener('click', function(event) {
      event.preventDefault();
      inputElement.value = currentValue;
      form.submit();
    });
    
    // Per la SEO, costruisci un href approssimativo come fallback
    const currentPath = window.location.pathname;
    const currentPathParts = currentPath.split('/').filter(Boolean);
    const currentLang = currentPathParts[0];
    
    let newPath = currentPath;
    if (currentLang && currentPathParts[0] === currentLang) {
      newPath = '/' + currentValue + currentPath.substring(currentLang.length + 1);
    } else {
      newPath = '/' + currentValue + currentPath;
    }
    
    const fullUrl = window.location.origin + newPath + window.location.search;
    link.href = fullUrl;
  });
});
